const RewardTypes = {
    Badge: 'badge',
    Proficiency: 'proficiency',
} as const;

export default RewardTypes;
